import { collapseThresholdShowIndicators } from '../../shared/utils/collapse-threshold-show-indicators.js';
import type { MeterBarChartThresholdIndicatorPropsInternal } from '../types/meter-bar-chart-internal.js';

/**
 * Resolves the effective chart-level `showThresholdIndicators` value from the
 * deprecated per-threshold `showIndicator` flags.
 *
 * The chart-level `showThresholdIndicators` prop always takes precedence and is
 * applied by the caller. This helper only kicks in as a fallback, so existing
 * configs that still rely on the per-threshold `showIndicator` flags keep
 * working without a breaking change. Returns `undefined` when no per-threshold
 * flag is set (or the values are indeterminate), signalling the caller to fall
 * back to the chart default.
 * @internal
 */
export function resolveShowThresholdIndicators(
  thresholds: MeterBarChartThresholdIndicatorPropsInternal[],
): boolean | undefined {
  return collapseThresholdShowIndicators(
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    thresholds.map((threshold) => threshold.showIndicator),
    '[MeterBarChart] The deprecated per-threshold `showIndicator` config has ' +
      'mixed values and can no longer be represented per threshold. Use the ' +
      'chart-level `showThresholdIndicators` prop to show or hide all threshold ' +
      'indicators at once.',
  );
}
